import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const VentureDevelopment = () => {
  const phases = [
    {
      icon: '📐',
      title: 'Planning & Design',
      description: 'Comprehensive project planning with expert architectural design'
    },
    {
      icon: '⚙️',
      title: 'Execution',
      description: 'Professional implementation with quality control at every stage'
    },
    {
      icon: '🏗️',
      title: 'Construction',
      description: 'High-quality construction using premium materials and techniques'
    },
    {
      icon: '✅',
      title: 'Delivery',
      description: 'Timely handover with complete compliance and documentation'
    }
  ];

  const commitments = [
    {
      icon: '💎',
      title: 'Premium Quality',
      description: 'Uncompromising standards in materials and workmanship'
    },
    {
      icon: '⏱️',
      title: 'Timely Delivery',
      description: 'Projects completed on schedule without delays'
    },
    {
      icon: '📜',
      title: 'Full Compliance',
      description: 'All regulations and legal requirements met'
    },
    {
      icon: '🤝',
      title: 'Transparent Process',
      description: 'Clear communication throughout the project lifecycle'
    }
  ];

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', 
      minHeight: '100vh',
      paddingTop: '60px',
      paddingBottom: '80px'
    }}>
      <Container>
        {/* Hero Section */}
        <div className="text-center mb-5">
          <div style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #FFBE1D 0%, #f0b000 100%)',
            padding: '12px 30px',
            borderRadius: '50px',
            marginBottom: '20px',
            boxShadow: '0 4px 15px rgba(255, 190, 29, 0.3)'
          }}>
            <span style={{ color: '#333', fontWeight: 700, fontSize: '1rem' }}>
              🏢 VENTURE DEVELOPMENT
            </span>
          </div>
          
          <h1 style={{
            color: '#2180CE',
            fontWeight: 800,
            fontSize: '3.5rem',
            marginBottom: '1.5rem',
            lineHeight: '1.2',
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
          }}>
            Building Tomorrow's Landmarks
          </h1>
          
          <p style={{
            fontSize: '1.3rem',
            color: '#495057',
            maxWidth: '850px',
            margin: '0 auto',
            lineHeight: '1.8'
          }}>
            From planning to execution, we handle every aspect of venture development with precision and expertise. 
            Trust Nakshatra Infra for exceptional quality and timely delivery.
          </p>
        </div>

        {/* Development Process */}
        <div className="mb-5">
          <div className="text-center mb-4">
            <h2 style={{
              color: '#2180CE',
              fontWeight: 700,
              fontSize: '2.5rem',
              marginBottom: '1rem'
            }}>
              Our Development Process
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#6c757d' }}>
              A systematic approach to excellence
            </p>
          </div>

          <Row className="g-4 mb-4">
            {phases.map((phase, index) => (
              <Col lg={3} md={6} key={index}>
                <Card style={{
                  border: 'none',
                  borderRadius: '20px',
                  boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
                  height: '100%',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 15px 40px rgba(255, 190, 29, 0.25)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.08)';
                }}>
                  <div style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    background: 'linear-gradient(135deg, #FFBE1D 0%, #f0b000 100%)',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    color: '#333',
                    fontSize: '1.1rem',
                    boxShadow: '0 4px 15px rgba(255, 190, 29, 0.3)'
                  }}>
                    {index + 1}
                  </div>
                  <Card.Body className="text-center p-4" style={{ paddingTop: '3rem' }}>
                    <div style={{
                      fontSize: '4rem',
                      marginBottom: '1rem'
                    }}>
                      {phase.icon}
                    </div>
                    <h4 style={{
                      color: '#2180CE',
                      fontWeight: 700,
                      marginBottom: '0.8rem',
                      fontSize: '1.3rem'
                    }}>
                      {phase.title}
                    </h4>
                    <p style={{
                      color: '#6c757d',
                      marginBottom: 0,
                      fontSize: '0.95rem',
                      lineHeight: '1.6'
                    }}>
                      {phase.description}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Process Flow Indicator */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '15px',
            marginTop: '30px'
          }}>
            <div style={{
              width: '50px',
              height: '4px',
              background: 'linear-gradient(90deg, #2180CE 0%, #FFBE1D 100%)',
              borderRadius: '2px'
            }} />
            <span style={{ color: '#6c757d', fontWeight: 600 }}>Seamless Project Flow</span>
            <div style={{
              width: '50px',
              height: '4px',
              background: 'linear-gradient(90deg, #FFBE1D 0%, #2180CE 100%)',
              borderRadius: '2px'
            }} />
          </div>
        </div>

        {/* Our Commitments */}
        <Card style={{
          border: 'none',
          borderRadius: '25px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
          overflow: 'hidden',
          marginBottom: '3rem'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #2180CE 0%, #1a6bb8 100%)',
            padding: '40px',
            textAlign: 'center',
            color: 'white'
          }}>
            <h2 style={{
              fontWeight: 800,
              fontSize: '2.5rem',
              marginBottom: '0.5rem'
            }}>
              Our Commitments to You
            </h2>
            <p style={{
              fontSize: '1.1rem',
              marginBottom: 0,
              opacity: 0.95
            }}>
              What sets Nakshatra Infra apart
            </p>
          </div>
          
          <Card.Body style={{ padding: '50px 40px' }}>
            <Row className="g-4">
              {commitments.map((commitment, index) => (
                <Col md={6} key={index}>
                  <div style={{
                    display: 'flex',
                    gap: '20px',
                    padding: '30px',
                    background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
                    borderRadius: '15px',
                    border: '2px solid #e9ecef',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#FFBE1D';
                    e.currentTarget.style.transform = 'translateX(10px)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(255, 190, 29, 0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#e9ecef';
                    e.currentTarget.style.transform = 'translateX(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}>
                    <div style={{
                      fontSize: '3rem',
                      flexShrink: 0
                    }}>
                      {commitment.icon}
                    </div>
                    <div>
                      <h5 style={{
                        color: '#2180CE',
                        fontWeight: 700,
                        marginBottom: '0.5rem',
                        fontSize: '1.3rem'
                      }}>
                        {commitment.title}
                      </h5>
                      <p style={{
                        color: '#6c757d',
                        marginBottom: 0,
                        fontSize: '1rem',
                        lineHeight: '1.6'
                      }}>
                        {commitment.description}
                      </p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>

        {/* Call to Action */}
        <Card style={{
          border: 'none',
          borderRadius: '25px',
          background: 'linear-gradient(135deg, #FFBE1D 0%, #f0b000 100%)',
          boxShadow: '0 15px 50px rgba(255, 190, 29, 0.3)',
          overflow: 'hidden'
        }}>
          <Card.Body style={{ padding: '60px 40px' }}>
            <Row className="align-items-center">
              <Col lg={8}>
                <h2 style={{
                  color: '#333',
                  fontWeight: 800,
                  fontSize: '2.5rem',
                  marginBottom: '1rem'
                }}>
                  Ready to Start Your Venture?
                </h2>
                <p style={{
                  fontSize: '1.2rem',
                  color: '#555',
                  marginBottom: 0,
                  lineHeight: '1.6'
                }}>
                  Partner with Nakshatra Infra for your next development project. 
                  Our expert team is ready to bring your vision to life with precision and excellence.
                </p>
              </Col>
              <Col lg={4} className="text-lg-end text-center mt-lg-0 mt-4">
                <a href="/contact" style={{
                  background: '#2180CE',
                  color: 'white',
                  padding: '18px 40px',
                  borderRadius: '12px',
                  fontWeight: 700,
                  fontSize: '1.1rem',
                  textDecoration: 'none',
                  display: 'inline-block',
                  boxShadow: '0 6px 20px rgba(33, 128, 206, 0.4)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-3px) scale(1.05)';
                  e.target.style.boxShadow = '0 8px 25px rgba(33, 128, 206, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0) scale(1)';
                  e.target.style.boxShadow = '0 6px 20px rgba(33, 128, 206, 0.4)';
                }}>
                  🚀 Let's Discuss Your Project
                </a>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default VentureDevelopment;